import React, { useState } from "react";

const PdfDisplayDoc = ({ image, title, width, height }) => {
  return (
    <div>
      <img
        alt={`${title}`}
        src={image}
        style={{ width: width, height: height }}
      />
    </div>
  );
};

export default PdfDisplayDoc;
